// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BGMTab-module__font-s-10___wJrly {
  font-size: 10px !important;
}

.BGMTab-module__font-s-12___DYPNs {
  font-size: 12px !important;
}

.BGMTab-module__font-s-13___vRFZd {
  font-size: 13px !important;
}

.BGMTab-module__font-s-14___PN5zU {
  font-size: 14px !important;
}

.BGMTab-module__font-s-15___qrwCW {
  font-size: 15px !important;
}

.BGMTab-module__font-s-16___v6iqH {
  font-size: 16px !important;
}

.BGMTab-module__font-s-18___R9u4a {
  font-size: 18px !important;
}

.BGMTab-module__font-s-20___ROKZ9 {
  font-size: 20px !important;
}

.BGMTab-module__font-s-22___M4dav {
  font-size: 22px !important;
}

.BGMTab-module__font-s-28___cae6a {
  font-size: 28px !important;
}

.BGMTab-module__font-w-400___mekM0 {
  font-weight: 400 !important;
}

.BGMTab-module__font-w-500___NB35P {
  font-weight: 500 !important;
}

.BGMTab-module__font-w-600___Kiq5w {
  font-weight: 600 !important;
}

.BGMTab-module__font-w-700___WscAC {
  font-weight: 700 !important;
}

.BGMTab-module__p-5___Xfd34 {
  padding: 5px !important;
}

.BGMTab-module__p-12___Ittc7 {
  padding: 12px !important;
}

.BGMTab-module__p-16___czQyD {
  padding: 16px !important;
}

.BGMTab-module__p-30___col5S {
  padding: 30px !important;
}

.BGMTab-module__p-b-0___iLm88 {
  padding-bottom: 0 !important;
}

.BGMTab-module__p-b-5___Ior0z {
  padding-bottom: 5px !important;
}

.BGMTab-module__p-b-10___NySjh {
  padding-bottom: 10px !important;
}

.BGMTab-module__p-b-12___qESQL {
  padding-bottom: 12px !important;
}

.BGMTab-module__p-b-16___Pcoe5 {
  padding-bottom: 16px !important;
}

.BGMTab-module__p-b-18___eCkiy {
  padding-bottom: 18px !important;
}

.BGMTab-module__p-b-20___H3ssX {
  padding-bottom: 20px !important;
}

.BGMTab-module__p-b-25___nR7jV {
  padding-bottom: 25px !important;
}

.BGMTab-module__p-b-30___chJ46 {
  padding-bottom: 30px !important;
}

.BGMTab-module__p-b-50___hFyA0 {
  padding-bottom: 50px !important;
}

.BGMTab-module__p-t-0___yAxQW {
  padding-top: 0 !important;
}

.BGMTab-module__p-t-12___alMa2 {
  padding-top: 12px !important;
}

.BGMTab-module__p-t-16___THUvT {
  padding-top: 16px !important;
}

.BGMTab-module__p-t-18___OFZAS {
  padding-top: 18px !important;
}

.BGMTab-module__p-t-20___pLs0R {
  padding-top: 20px !important;
}

.BGMTab-module__p-t-30___H7VIY {
  padding-top: 30px !important;
}

.BGMTab-module__p-t-40___J262p {
  padding-top: 40px !important;
}

.BGMTab-module__p-t-50___NG4o9 {
  padding-top: 50px !important;
}

.BGMTab-module__p-l-20___lCoUl {
  padding-left: 20px !important;
}

.BGMTab-module__p-l-30___aXCty {
  padding-left: 30px !important;
}

.BGMTab-module__p-l-40___NX8X0 {
  padding-left: 40px !important;
}

.BGMTab-module__p-r-16___uR9Pt {
  padding-right: 16px !important;
}

.BGMTab-module__p-r-20___ClmUk {
  padding-right: 20px !important;
}

.BGMTab-module__p-r-30___emERl {
  padding-right: 30px !important;
}

.BGMTab-module__p-r-50___e4FW0 {
  padding-right: 50px !important;
}

.BGMTab-module__p-r-60___dHH5W {
  padding-right: 60px !important;
}

.BGMTab-module__m-b-1___zRqv2 {
  margin-bottom: 1px !important;
}

.BGMTab-module__m-b-2___zFZCq {
  margin-bottom: 2px !important;
}

.BGMTab-module__m-b-6___KjLw1 {
  margin-bottom: 6px !important;
}

.BGMTab-module__m-b-8___MtQBE {
  margin-bottom: 8px !important;
}

.BGMTab-module__m-b-10___HAp7U {
  margin-bottom: 10px !important;
}

.BGMTab-module__m-b-14___pmodd {
  margin-bottom: 14px !important;
}

.BGMTab-module__m-b-16___XL3xo {
  margin-bottom: 16px !important;
}

.BGMTab-module__m-b-20___nfvN2 {
  margin-bottom: 20px !important;
}

.BGMTab-module__m-b-22___P2a6_ {
  margin-bottom: 22px !important;
}

.BGMTab-module__m-b-24___HKvae {
  margin-bottom: 24px !important;
}

.BGMTab-module__m-b-30____fAfN {
  margin-bottom: 30px !important;
}

.BGMTab-module__m-b-32___UQkmm {
  margin-bottom: 32px !important;
}

.BGMTab-module__m-b-40___lIP6W {
  margin-bottom: 40px !important;
}

.BGMTab-module__m-t-2___LKFEL {
  margin-top: 2px !important;
}

.BGMTab-module__m-t-3___hVieM {
  margin-top: 3px !important;
}

.BGMTab-module__m-t-4___m0LXk {
  margin-top: 4px !important;
}

.BGMTab-module__m-t-5___GMDVf {
  margin-top: 5px !important;
}

.BGMTab-module__m-t-8___KrPLH {
  margin-top: 8px !important;
}

.BGMTab-module__m-t-10___uCoZr {
  margin-top: 10px !important;
}

.BGMTab-module__m-t-15___OwYlw {
  margin-top: 15px !important;
}

.BGMTab-module__m-t-16___hJpW0 {
  margin-top: 16px !important;
}

.BGMTab-module__m-t-20___GDksm {
  margin-top: 20px !important;
}

.BGMTab-module__m-t-22___uDmd1 {
  margin-top: 22px !important;
}

.BGMTab-module__m-t-30___A2m0g {
  margin-top: 30px !important;
}

.BGMTab-module__m-t-32___mXqAt {
  margin-top: 32px !important;
}

.BGMTab-module__m-l-auto___NfREz {
  margin-left: auto !important;
}

.BGMTab-module__m-l-4___cUEKu {
  margin-left: 4px !important;
}

.BGMTab-module__m-l-5___EDF4p {
  margin-left: 5px !important;
}

.BGMTab-module__m-l-6___LXmsA {
  margin-left: 6px !important;
}

.BGMTab-module__m-l-8___AfZAJ {
  margin-left: 8px !important;
}

.BGMTab-module__m-l-10___JvYkN {
  margin-left: 10px !important;
}

.BGMTab-module__m-l-16___FTVRl {
  margin-left: 16px !important;
}

.BGMTab-module__m-l-20___WbYww {
  margin-left: 20px !important;
}

.BGMTab-module__m-l-24___gkTHZ {
  margin-left: 24px !important;
}

.BGMTab-module__m-l-30___J3zme {
  margin-left: 30px !important;
}

.BGMTab-module__m-l-35___uYbD7 {
  margin-left: 35px !important;
}

.BGMTab-module__m-l-40___WKkDT {
  margin-left: 40px !important;
}

.BGMTab-module__m-r-8___Vtiea {
  margin-right: 8px !important;
}

.BGMTab-module__m-r-10___hOtJP {
  margin-right: 10px !important;
}

.BGMTab-module__m-r-16___LG2zH {
  margin-right: 16px !important;
}

.BGMTab-module__m-r-20___cnQnD {
  margin-right: 20px !important;
}

.BGMTab-module__m-r-24___eU8fm {
  margin-right: 24px !important;
}

.BGMTab-module__m-r-30___oPgjC {
  margin-right: 30px !important;
}

.BGMTab-module__m-r-40___apWa1 {
  margin-right: 40px !important;
}

.BGMTab-module__border-r-3___5UNIn {
  border-radius: 3px !important;
}

.BGMTab-module__border-r-4___KtrAi {
  border-radius: 4px !important;
}

.BGMTab-module__border-r-6___TM_8i {
  border-radius: 6px !important;
}

.BGMTab-module__border-r-10___tgw7O {
  border-radius: 10px !important;
}

.BGMTab-module__border-r-12___htFbK {
  border-radius: 12px !important;
}

.BGMTab-module__border-r-16___A0H99 {
  border-radius: 16px !important;
}

.BGMTab-module__border-r-50___xCFBI {
  border-radius: 50% !important;
}

.BGMTab-module__primary-border___dBxwk {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMTab-module__primary-border-b___kAtSh {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMTab-module__primary-border-t___KB_1i {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMTab-module__primary-border-l___Nmuq9 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMTab-module__primary-border-r___Ffzlj {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.BGMTab-module__secondary-border___xcb5C {
  border: 1px solid #637768;
}

.BGMTab-module__secondary-border-b___AyiBg {
  border-bottom: 1px solid #637768;
}

.BGMTab-module__secondary-border-t___ypFEo {
  border-top: 1px solid #637768;
}

.BGMTab-module__secondary-border-l___xvfvj {
  border-left: 1px solid #637768;
}

.BGMTab-module__secondary-border-r___L_P0y {
  border-right: 1px solid #637768;
}

.BGMTab-module__gap-0___cgQz5 {
  gap: 0 !important;
}

.BGMTab-module__gap-2___svNO5 {
  gap: 2px !important;
}

.BGMTab-module__gap-4___uKfiV {
  gap: 4px !important;
}

.BGMTab-module__gap-5___UazR4 {
  gap: 5px !important;
}

.BGMTab-module__gap-6___zbbCp {
  gap: 6px !important;
}

.BGMTab-module__gap-8___tikOb {
  gap: 8px !important;
}

.BGMTab-module__gap-10___NufCf {
  gap: 10px !important;
}

.BGMTab-module__gap-12___TMzNB {
  gap: 12px !important;
}

.BGMTab-module__gap-14___DpvuK {
  gap: 14px !important;
}

.BGMTab-module__gap-16___FYdO1 {
  gap: 16px !important;
}

.BGMTab-module__gap-18___ijaSh {
  gap: 18px !important;
}

.BGMTab-module__gap-20___NvyV9 {
  gap: 20px !important;
}

.BGMTab-module__gap-24___ycHxD {
  gap: 24px !important;
}

.BGMTab-module__gap-26___lnEr_ {
  gap: 26px !important;
}

.BGMTab-module__gap-30___fXGSL {
  gap: 30px !important;
}

.BGMTab-module__gap-32___KnR7H {
  gap: 32px !important;
}

.BGMTab-module__gap-40___lS80l {
  gap: 40px !important;
}

.BGMTab-module__gap-50___S8FJ5 {
  gap: 50px !important;
}

.BGMTab-module__flex-1___oCEHR {
  flex: 1;
}

.BGMTab-module__flex-none___AGG2M {
  flex: none !important;
}

.BGMTab-module__flex-column___M8M7v {
  display: flex;
  flex-direction: column !important;
}

.BGMTab-module__flex-row___fiHPX {
  display: flex;
  flex-direction: row !important;
}

.BGMTab-module__vertically-centered___RAAbT {
  display: flex;
  align-items: center !important;
}

.BGMTab-module__horizontally-centered___uLEfS {
  display: flex;
  justify-content: center !important;
}

.BGMTab-module__horizontally-end___BAU8L {
  display: flex;
  justify-content: end !important;
}

.BGMTab-module__vertically-start___C9Vnc {
  display: flex;
  align-items: start !important;
}

.BGMTab-module__space-between___EEMsZ {
  display: flex;
  justify-content: space-between !important;
}

.BGMTab-module__flex-wrap___C5hli {
  flex-wrap: wrap !important;
}

.BGMTab-module__height-100___vRPss {
  height: 100%;
}

.BGMTab-module__width-50___bb_li {
  width: 50% !important;
}

.BGMTab-module__width-100___UVTnB {
  width: 100%;
}

.BGMTab-module__cursor-pointer___kM2Fc {
  cursor: pointer;
}

.BGMTab-module__cursor-not-allowed___F2RGk {
  cursor: not-allowed !important;
}

.BGMTab-module__absolute-centered___hL36C {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.BGMTab-module__absolute___KGLy9 {
  position: absolute;
}

.BGMTab-module__relative___2S1Mv {
  position: relative;
}

.BGMTab-module__fixed___COJ0A {
  position: fixed;
}

.BGMTab-module__visible___Cs_Ce {
  opacity: 1;
}

.BGMTab-module__invisible___fGGuc {
  opacity: 0;
}

.BGMTab-module__col-90___tSNii {
  width: 90% !important;
}

.BGMTab-module__col-auto___orzTK {
  width: auto !important;
}

.BGMTab-module__medical-tabs___aoYDc {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.BGMTab-module__medical-table-new___D2sj5 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMTab-module__medical-table-new___D2sj5:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMTab-module__medical-table-new___D2sj5::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMTab-module__medical-table-new___D2sj5::-webkit-scrollbar-track {
  display: none;
}
.BGMTab-module__medical-table-new___D2sj5.BGMTab-module__no-pagination___xfCLs {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMTab-module__medical-table-new___D2sj5.BGMTab-module__no-pagination___xfCLs:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMTab-module__medical-table-new___D2sj5.BGMTab-module__no-pagination___xfCLs::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMTab-module__medical-table-new___D2sj5.BGMTab-module__no-pagination___xfCLs::-webkit-scrollbar-track {
  display: none;
}

.BGMTab-module__medical-table-empty___a1fPz {
  padding: 14px 40px !important;
}

.BGMTab-module__icon-btn___vOX7T {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.BGMTab-module__search-icon___SI5_x {
  width: 24px;
  height: 24px;
  align-self: center;
}

.BGMTab-module__disable-select___FvbeU {
  user-select: none;
}

.BGMTab-module__break-word___wgslB {
  word-break: break-word;
}

.BGMTab-module__popup-clear-btn___f5YK7 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.BGMTab-module__scroll-m-b-20___kXRhD {
  scroll-margin-bottom: 20px;
}

.BGMTab-module__scroll___DWGac {
  position: relative;
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer) - 210px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.BGMTab-module__scroll___DWGac:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.BGMTab-module__scroll___DWGac::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.BGMTab-module__scroll___DWGac::-webkit-scrollbar-track {
  display: none;
}
.BGMTab-module__scroll___DWGac .BGMTab-module__sticky___yOf_0 {
  background-color: white;
  position: sticky;
  z-index: 10;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/tabs/BGMTab/BGMTab.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;ECOA,mHDLE;ECMF,kBAAA;EACA,kBAAA;ADwpBF;ACtpBE;EACE,oCAAA;EACA,mBAAA;ADwpBJ;ACrpBE;EACE,UAAA;EACA,6BAAA;ADupBJ;ACppBE;EACE,aAAA;ADspBJ;AApqBE;EACE,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,MAAA;AAsqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.scroll {\n  position: relative;\n  @include verticalScroll(\n    calc(\n      100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer) -\n        210px\n    )\n  );\n\n  .sticky {\n    background-color: get-color(white);\n    position: sticky;\n    z-index: 10;\n    top: 0;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `BGMTab-module__font-s-10___wJrly`,
	"fontS12": `BGMTab-module__font-s-12___DYPNs`,
	"fontS13": `BGMTab-module__font-s-13___vRFZd`,
	"fontS14": `BGMTab-module__font-s-14___PN5zU`,
	"fontS15": `BGMTab-module__font-s-15___qrwCW`,
	"fontS16": `BGMTab-module__font-s-16___v6iqH`,
	"fontS18": `BGMTab-module__font-s-18___R9u4a`,
	"fontS20": `BGMTab-module__font-s-20___ROKZ9`,
	"fontS22": `BGMTab-module__font-s-22___M4dav`,
	"fontS28": `BGMTab-module__font-s-28___cae6a`,
	"fontW400": `BGMTab-module__font-w-400___mekM0`,
	"fontW500": `BGMTab-module__font-w-500___NB35P`,
	"fontW600": `BGMTab-module__font-w-600___Kiq5w`,
	"fontW700": `BGMTab-module__font-w-700___WscAC`,
	"p5": `BGMTab-module__p-5___Xfd34`,
	"p12": `BGMTab-module__p-12___Ittc7`,
	"p16": `BGMTab-module__p-16___czQyD`,
	"p30": `BGMTab-module__p-30___col5S`,
	"pB0": `BGMTab-module__p-b-0___iLm88`,
	"pB5": `BGMTab-module__p-b-5___Ior0z`,
	"pB10": `BGMTab-module__p-b-10___NySjh`,
	"pB12": `BGMTab-module__p-b-12___qESQL`,
	"pB16": `BGMTab-module__p-b-16___Pcoe5`,
	"pB18": `BGMTab-module__p-b-18___eCkiy`,
	"pB20": `BGMTab-module__p-b-20___H3ssX`,
	"pB25": `BGMTab-module__p-b-25___nR7jV`,
	"pB30": `BGMTab-module__p-b-30___chJ46`,
	"pB50": `BGMTab-module__p-b-50___hFyA0`,
	"pT0": `BGMTab-module__p-t-0___yAxQW`,
	"pT12": `BGMTab-module__p-t-12___alMa2`,
	"pT16": `BGMTab-module__p-t-16___THUvT`,
	"pT18": `BGMTab-module__p-t-18___OFZAS`,
	"pT20": `BGMTab-module__p-t-20___pLs0R`,
	"pT30": `BGMTab-module__p-t-30___H7VIY`,
	"pT40": `BGMTab-module__p-t-40___J262p`,
	"pT50": `BGMTab-module__p-t-50___NG4o9`,
	"pL20": `BGMTab-module__p-l-20___lCoUl`,
	"pL30": `BGMTab-module__p-l-30___aXCty`,
	"pL40": `BGMTab-module__p-l-40___NX8X0`,
	"pR16": `BGMTab-module__p-r-16___uR9Pt`,
	"pR20": `BGMTab-module__p-r-20___ClmUk`,
	"pR30": `BGMTab-module__p-r-30___emERl`,
	"pR50": `BGMTab-module__p-r-50___e4FW0`,
	"pR60": `BGMTab-module__p-r-60___dHH5W`,
	"mB1": `BGMTab-module__m-b-1___zRqv2`,
	"mB2": `BGMTab-module__m-b-2___zFZCq`,
	"mB6": `BGMTab-module__m-b-6___KjLw1`,
	"mB8": `BGMTab-module__m-b-8___MtQBE`,
	"mB10": `BGMTab-module__m-b-10___HAp7U`,
	"mB14": `BGMTab-module__m-b-14___pmodd`,
	"mB16": `BGMTab-module__m-b-16___XL3xo`,
	"mB20": `BGMTab-module__m-b-20___nfvN2`,
	"mB22": `BGMTab-module__m-b-22___P2a6_`,
	"mB24": `BGMTab-module__m-b-24___HKvae`,
	"mB30": `BGMTab-module__m-b-30____fAfN`,
	"mB32": `BGMTab-module__m-b-32___UQkmm`,
	"mB40": `BGMTab-module__m-b-40___lIP6W`,
	"mT2": `BGMTab-module__m-t-2___LKFEL`,
	"mT3": `BGMTab-module__m-t-3___hVieM`,
	"mT4": `BGMTab-module__m-t-4___m0LXk`,
	"mT5": `BGMTab-module__m-t-5___GMDVf`,
	"mT8": `BGMTab-module__m-t-8___KrPLH`,
	"mT10": `BGMTab-module__m-t-10___uCoZr`,
	"mT15": `BGMTab-module__m-t-15___OwYlw`,
	"mT16": `BGMTab-module__m-t-16___hJpW0`,
	"mT20": `BGMTab-module__m-t-20___GDksm`,
	"mT22": `BGMTab-module__m-t-22___uDmd1`,
	"mT30": `BGMTab-module__m-t-30___A2m0g`,
	"mT32": `BGMTab-module__m-t-32___mXqAt`,
	"mLAuto": `BGMTab-module__m-l-auto___NfREz`,
	"mL4": `BGMTab-module__m-l-4___cUEKu`,
	"mL5": `BGMTab-module__m-l-5___EDF4p`,
	"mL6": `BGMTab-module__m-l-6___LXmsA`,
	"mL8": `BGMTab-module__m-l-8___AfZAJ`,
	"mL10": `BGMTab-module__m-l-10___JvYkN`,
	"mL16": `BGMTab-module__m-l-16___FTVRl`,
	"mL20": `BGMTab-module__m-l-20___WbYww`,
	"mL24": `BGMTab-module__m-l-24___gkTHZ`,
	"mL30": `BGMTab-module__m-l-30___J3zme`,
	"mL35": `BGMTab-module__m-l-35___uYbD7`,
	"mL40": `BGMTab-module__m-l-40___WKkDT`,
	"mR8": `BGMTab-module__m-r-8___Vtiea`,
	"mR10": `BGMTab-module__m-r-10___hOtJP`,
	"mR16": `BGMTab-module__m-r-16___LG2zH`,
	"mR20": `BGMTab-module__m-r-20___cnQnD`,
	"mR24": `BGMTab-module__m-r-24___eU8fm`,
	"mR30": `BGMTab-module__m-r-30___oPgjC`,
	"mR40": `BGMTab-module__m-r-40___apWa1`,
	"borderR3": `BGMTab-module__border-r-3___5UNIn`,
	"borderR4": `BGMTab-module__border-r-4___KtrAi`,
	"borderR6": `BGMTab-module__border-r-6___TM_8i`,
	"borderR10": `BGMTab-module__border-r-10___tgw7O`,
	"borderR12": `BGMTab-module__border-r-12___htFbK`,
	"borderR16": `BGMTab-module__border-r-16___A0H99`,
	"borderR50": `BGMTab-module__border-r-50___xCFBI`,
	"primaryBorder": `BGMTab-module__primary-border___dBxwk`,
	"primaryBorderB": `BGMTab-module__primary-border-b___kAtSh`,
	"primaryBorderT": `BGMTab-module__primary-border-t___KB_1i`,
	"primaryBorderL": `BGMTab-module__primary-border-l___Nmuq9`,
	"primaryBorderR": `BGMTab-module__primary-border-r___Ffzlj`,
	"secondaryBorder": `BGMTab-module__secondary-border___xcb5C`,
	"secondaryBorderB": `BGMTab-module__secondary-border-b___AyiBg`,
	"secondaryBorderT": `BGMTab-module__secondary-border-t___ypFEo`,
	"secondaryBorderL": `BGMTab-module__secondary-border-l___xvfvj`,
	"secondaryBorderR": `BGMTab-module__secondary-border-r___L_P0y`,
	"gap0": `BGMTab-module__gap-0___cgQz5`,
	"gap2": `BGMTab-module__gap-2___svNO5`,
	"gap4": `BGMTab-module__gap-4___uKfiV`,
	"gap5": `BGMTab-module__gap-5___UazR4`,
	"gap6": `BGMTab-module__gap-6___zbbCp`,
	"gap8": `BGMTab-module__gap-8___tikOb`,
	"gap10": `BGMTab-module__gap-10___NufCf`,
	"gap12": `BGMTab-module__gap-12___TMzNB`,
	"gap14": `BGMTab-module__gap-14___DpvuK`,
	"gap16": `BGMTab-module__gap-16___FYdO1`,
	"gap18": `BGMTab-module__gap-18___ijaSh`,
	"gap20": `BGMTab-module__gap-20___NvyV9`,
	"gap24": `BGMTab-module__gap-24___ycHxD`,
	"gap26": `BGMTab-module__gap-26___lnEr_`,
	"gap30": `BGMTab-module__gap-30___fXGSL`,
	"gap32": `BGMTab-module__gap-32___KnR7H`,
	"gap40": `BGMTab-module__gap-40___lS80l`,
	"gap50": `BGMTab-module__gap-50___S8FJ5`,
	"flex1": `BGMTab-module__flex-1___oCEHR`,
	"flexNone": `BGMTab-module__flex-none___AGG2M`,
	"flexColumn": `BGMTab-module__flex-column___M8M7v`,
	"flexRow": `BGMTab-module__flex-row___fiHPX`,
	"verticallyCentered": `BGMTab-module__vertically-centered___RAAbT`,
	"horizontallyCentered": `BGMTab-module__horizontally-centered___uLEfS`,
	"horizontallyEnd": `BGMTab-module__horizontally-end___BAU8L`,
	"verticallyStart": `BGMTab-module__vertically-start___C9Vnc`,
	"spaceBetween": `BGMTab-module__space-between___EEMsZ`,
	"flexWrap": `BGMTab-module__flex-wrap___C5hli`,
	"height100": `BGMTab-module__height-100___vRPss`,
	"width50": `BGMTab-module__width-50___bb_li`,
	"width100": `BGMTab-module__width-100___UVTnB`,
	"cursorPointer": `BGMTab-module__cursor-pointer___kM2Fc`,
	"cursorNotAllowed": `BGMTab-module__cursor-not-allowed___F2RGk`,
	"absoluteCentered": `BGMTab-module__absolute-centered___hL36C`,
	"absolute": `BGMTab-module__absolute___KGLy9`,
	"relative": `BGMTab-module__relative___2S1Mv`,
	"fixed": `BGMTab-module__fixed___COJ0A`,
	"visible": `BGMTab-module__visible___Cs_Ce`,
	"invisible": `BGMTab-module__invisible___fGGuc`,
	"col90": `BGMTab-module__col-90___tSNii`,
	"colAuto": `BGMTab-module__col-auto___orzTK`,
	"medicalTabs": `BGMTab-module__medical-tabs___aoYDc`,
	"medicalTableNew": `BGMTab-module__medical-table-new___D2sj5`,
	"noPagination": `BGMTab-module__no-pagination___xfCLs`,
	"medicalTableEmpty": `BGMTab-module__medical-table-empty___a1fPz`,
	"iconBtn": `BGMTab-module__icon-btn___vOX7T`,
	"searchIcon": `BGMTab-module__search-icon___SI5_x`,
	"disableSelect": `BGMTab-module__disable-select___FvbeU`,
	"breakWord": `BGMTab-module__break-word___wgslB`,
	"popupClearBtn": `BGMTab-module__popup-clear-btn___f5YK7`,
	"scrollMB20": `BGMTab-module__scroll-m-b-20___kXRhD`,
	"scroll": `BGMTab-module__scroll___DWGac`,
	"sticky": `BGMTab-module__sticky___yOf_0`
};
module.exports = ___CSS_LOADER_EXPORT___;
